import { css } from "@emotion/react";

import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { Suspense } from "react";

export const AccountMovements = () => {
  return (
    <div css={container}>
      <Suspense fallback={null}>
        <ResourceList
          hideToolbarCreateNewRecordButton
          resource={ResourceEnum.AccountMovement}
        />
      </Suspense>
    </div>
  );
};

const container = css`
  margin: 15px;
  height: 95%;
`;
